import request from '../../axios';

export const getStoryLimit = async () => {
  const {data}: {data: limitStoryResponse} = await request.get(
    'api/v2/store/remained-stroy-limit',
  );
  return data;
};
